import React from "react";
import "./QuotationTicker.css";

const QuotationTicker = () => {
  return (
    <div className="quote-ticker-wrapper">
      <div className="quote-ticker">
        <span>
          “प्रज्ञा कल्पना सृजनं नेतृत्वं विकासः” - Wisdom, imagination, creativity, leadership and holistic growth
        </span>
      </div>
    </div>
  );
};

export default QuotationTicker;
